export default [
  {
    srno: "1",
    title: "Personal Development",
    subtitle: "2",
    description: "Lorem ipsum enpidar inadar turlam malam lorem sumip",
    iconimg: require("../img/logo1.png")
  },
  {
    srno: "2",
    title: "Development",
    subtitle: "2",
    description: "Lorem ipsum enpidar inadar turlam malam lorem sumip",
    iconimg: require("../img/logo1.png")
  },
  {
    srno: "3",
    title: "Marketing ",
    subtitle: "2",
    description: "Lorem ipsum enpidar inadar turlam malam lorem sumip",
    iconimg: require("../img/logo1.png")
  },
  {
    srno: "4",
    title: "Design",
    subtitle: "2",
    description: "Lorem ipsum enpidar inadar turlam malam lorem sumip",
    iconimg: require("../img/logo1.png")
  }
];
